import React from "react";
import { withStyles } from "material-ui/styles";
import PropTypes from "prop-types";

import Button from "material-ui/Button";
import Divider from "material-ui/Divider";

const styles = {
  root: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "row-reverse",
    paddingRight: 8
  }
};

const CardButtonRow = props => {
  const { disabled, buttons } = props;

  const renderButtons = () => {
    return buttons.map((b, i) => (
      <Button key={i} color="primary" disabled={disabled} onClick={b.action}>
        {b.label}
      </Button>
    ));
  };
  return (
    <div>
      <Divider />
      <div className={props.classes.root}>{renderButtons()}</div>
    </div>
  );
};

CardButtonRow.propTypes = {
  disabled: PropTypes.bool.isRequired,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      action: PropTypes.func.isRequired
    })
  )
};

CardButtonRow.defaultProps = {
  disabled: false,
  buttons: []
};

export { CardButtonRow };

export default withStyles(styles, { name: "CardButtonRow" })(CardButtonRow);



// WEBPACK FOOTER //
// ./src/CardButtonRow.js